import Slider from '@ui/Slider/component'
import ImagesSlider from 'assets/core/js/module/imagesSlider'
import type { SliderOptions } from '@ui/Slider/component'

export default function (): void {
  ImagesSlider(document.querySelector<HTMLElement>('.booking__product .slider') as HTMLElement)

  const defaultConfig: SliderOptions = {
    speed: 1000,
    slidesPerView: 1,
    pagination: {
      clickable: true,
      el: '#booking-product-top-reviews-slider-pagination',
    },
  }

  Slider('#booking-product-top-reviews-slider', defaultConfig)
}
